import { Button, Carousel, Spin } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Background from '../../../assets/images/demo_banner.png';
import { BannerResponse } from "../../../redux/api/apiTypes";
import { useLazyGetBannerListQuery } from "../../../redux/api/SystemApi";

const HeaderCarousel = () => {
    const [imageList, setImageList] = useState<BannerResponse[]>([]);
    const [size, setSize] = useState<number[]>([0, 0])
    const [bannerTrigger, bannerResponse] = useLazyGetBannerListQuery();

    useEffect(() => {
        const handleResize = () => {
            // let height = Math.ceil(window.document.documentElement.clientWidth * 24 / 100);
            setSize([window.document.documentElement.clientWidth, 450])

        }

        handleResize();

        window.addEventListener('resize', handleResize)

        return (() => {
            window.removeEventListener('resize', handleResize);
        })
    }, [])

    useEffect(() => {
        bannerTrigger({ page: 0, size: 1000, status: 1 })
    }, [bannerTrigger])

    useEffect(() => {
        if (bannerResponse.data) {
            let newImageList: BannerResponse[] = [];
            if (bannerResponse.data.content.length) {
                bannerResponse.data.content.forEach(item => {
                    if (item.urlResize) {
                        let url = item.urlResize.replace("%RESIZING_TYPE", "fit")
                            .replace("%WIDTH", size[0].toString())
                            .replace("%HEIGHT", size[1].toString())
                            .replace("%ENLARGE", "0")
                            .replace(process.env.REACT_APP_BASE_API_URL || "", process.env.REACT_APP_IMAGE_URL || "")
                        newImageList.push({
                            ...item,
                            urlResize: url
                        });
                    }
                })
            }
            setImageList(newImageList);
        }
    }, [bannerResponse.data, size])

    return (
        <div style={{
            position: 'relative',
            width: size[0],
            height: size[1],
            borderBottom: '1px solid #cecece',
            borderTop: '1px solid #cecece'
        }}>
            {/* <div style={{ position: 'absolute', zIndex: 1, color: 'white', display: 'flex', alignItems: 'center', left: 200, top: '55%' }}>
                <div style={{ lineHeight: 1 }}>
                    <div style={{ marginLeft: '90px' }}>
                        {!bannerResponse.isLoading && !bannerResponse.isFetching ?
                            <Button
                                className="button-light-yellow"
                                style={{ height: 50, width: 240, fontSize: 16, marginTop: '60px' }}
                            >
                                <Link to='/auction-register'>ĐĂNG KÝ BÁN ĐẤU GIÁ</Link>
                            </Button> : <></>}
                    </div>
                </div>
            </div> */}

            {bannerResponse.isLoading || bannerResponse.isFetching ?
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                    }}>
                    <Spin size="large" />
                </div>
                : <></>}

            {bannerResponse.data?.content.length ?
                <Carousel className="header-carousel" autoplay autoplaySpeed={5000}>
                    {imageList.map((item, index) => (
                        <div key={index}>
                            <a href={item.url} target="_blank" rel="noreferrer">
                                <div
                                    style={{
                                        backgroundImage: `url(${item.urlResize})`,
                                        width: size[0],
                                        height: size[1],
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        cursor: 'pointer'
                                    }}>
                                </div>
                            </a>
                        </div>
                    ))}

                </Carousel>
                : <div>
                    <div
                        style={{
                            backgroundImage: `url(${Background})`,
                            width: size[0],
                            height: size[1],
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}>
                    </div>
                </div>}
        </div>
    )
}

export default HeaderCarousel;